import { AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ModeSwitch from "../ModeSwitch";
import Button from "../form/button";
import ScrollToTop from "../scollToTop";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";
import CommandMenu from "./CommandMenu";
import StudioNavigation, { StudioNavigationContent } from "./StudioNavigation";
import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuTrigger } from "../ui/contextmenu";

export default function StudioLayout() {
    const [showNavigation, setShowNavigation] = useState(localStorage.getItem("ReinVB_Studio_showNavigationState") === "true");
    const [mobileNavigation, setMobileNavigation] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setMobileNavigation(false);
    }, [location]);

    useEffect(() => {
        localStorage.setItem("ReinVB_Studio_showNavigationState", showNavigation ? "true" : "false");
    }, [showNavigation]);

    function handleKeyPress(event: KeyboardEvent) {
        if (event.altKey && event.code === "KeyS") {
            event.preventDefault();
            setShowNavigation(!showNavigation);
        }
    }

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);

    return (
        <div className="min-h-[100dvh] bg-white text-slate-700 dark:bg-slate-900 dark:text-slate-200">
            <ScrollToTop />
            <div className="flex">
                <div className="hidden lg:block">
                    <AnimatePresence>{showNavigation && <StudioNavigation />}</AnimatePresence>
                </div>
                <div className="scrollbar h-[100dvh] w-full overflow-y-auto">
                    <div className="flex h-16 items-center justify-between bg-white px-4 dark:bg-slate-900 md:px-8">
                        <div className="hidden lg:block">
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger>
                                        <Button onClick={() => setShowNavigation(!showNavigation)} variant={"ghost"} size={"ghost"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                                            </svg>
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                        <kbd className="pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground opacity-100">
                                            <span className="text-xs">ALT</span> + S
                                        </kbd>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                        <div className="hidden lg:block">
                            <CommandMenu />
                        </div>
                        <div className="block lg:hidden">
                            <Sheet open={mobileNavigation} onOpenChange={setMobileNavigation}>
                                <SheetTrigger>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-6 w-6">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                                    </svg>
                                </SheetTrigger>
                                <SheetContent position={"left"} className="flex min-h-[100dvh] w-96 flex-col bg-slate-100 p-0 dark:bg-slate-950">
                                    <StudioNavigationContent />
                                </SheetContent>
                            </Sheet>
                        </div>

                        <ModeSwitch />
                    </div>

                    <Outlet />
                </div>
            </div>
        </div>
    );
}
